import React from 'react';
import styled from '@xstyled/styled-components';

// #region Styles
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
  z-index: 1001;
`;

const ModalButtons = styled.div`
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  align-items: center;

  button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    align-items: center;
  }
`;


const CancelButton = styled.button`
  background-color: #f5f5f5;
  color: black;
`;

const YesButton = styled.button`
  background-color: #4CAF50;
  color: white;
`;

const NoButton = styled.button`
  background-color: #f44336;
  color: white;
`;

const PrimaryButton = styled.button`
  background-color: #e3c517;
  color: rgb(0, 0, 0);
`;

const buttonTypes = {
  yesButton: YesButton,
  noButton: NoButton,
  cancelButton: CancelButton,
  primaryButton: PrimaryButton,
};
// #endregion Styles

const ConfirmationModal = ({ message, buttons }) => {
  return (
    <ModalOverlay>
      <ModalContent>
        <p>{message}</p>
        <ModalButtons>
          {buttons.map(([label, handler, styleName = "modalButton"], index) => {
            const ButtonComponent = buttonTypes[styleName] || PrimaryButton;
            return (
              <ButtonComponent key={index} onClick={handler}>
                {label}
              </ButtonComponent>)}
          )}
        </ModalButtons>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ConfirmationModal;
